import { useEffect } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import ClipLoader from "react-spinners/ClipLoader";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { formatDateStandar } from "../../../../helpers/utils";
import {
  getEmailConfirmationByRegId,
  selectEmailTermsValidations,
  selectLoadingEmailTermsValidations,
} from "../coreIdSlice";

export interface EmailTermsValidationsViewProps {
  regId: string;
}

export const EmailTermsValidationsView = (
  props: EmailTermsValidationsViewProps
) => {
  const { regId } = props;
  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectLoadingEmailTermsValidations);
  const emailTermsValidations = useAppSelector(selectEmailTermsValidations);

  useEffect(() => {
    if (regId) {
      dispatch(getEmailConfirmationByRegId(regId));
    }
  }, [regId]);

  const renderMessage = (message: string) => (
    <div
      className="flex-col text-normal text-medium primary-color"
      style={{
        width: "100%",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        boxSizing: "border-box",
        padding: "20px",
      }}
    >
      {message}
    </div>
  );

  const renderContent = () => {
    switch (loading) {
      case "pending":
        return (
          <LoadingOverlay
            active={true}
            spinner={<ClipLoader color="white" size="60px" />}
          ></LoadingOverlay>
        );
      case "rejected":
        return renderMessage("No pudimos cargar las validaciones de correo");
      case "resolved":
        if (!emailTermsValidations || emailTermsValidations.length === 0) {
          return renderMessage(
            "No existen validaciones de correo para este registro"
          );
        }
        return (
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead
              className="text-normal text-medium primary-color-35"
              style={{
                background: "rgba(0,0,0,0.4)",
                height: "30px",
                textAlign: "center",
              }}
            >
              <tr>
                <th>Correo</th>
                <th>Confirmado</th>
                <th>Fecha de confirmación</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody
              className="text-normal text-x-small primary-color"
              style={{ textAlign: "center" }}
            >
              {emailTermsValidations.map((validation, i) => (
                <tr key={validation.code ?? i} style={{ height: "30px" }}>
                  <td>{validation.email || "-"}</td>
                  <td>{validation.confirmed ? "Sí" : "No"}</td>
                  <td>
                    {validation.dateConfirmed
                      ? formatDateStandar(String(validation.dateConfirmed))
                      : "-"}
                  </td>
                  <td>{validation.ip || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className="flex-col" style={{ width: "100%" }}>
      {renderContent()}
    </div>
  );
};
